import React from 'react';

const DeviceContext = React.createContext({
	os: '',
	browser: '',
	device: '',
	updateDevice: () => {},
});

export default DeviceContext;
